import Vue from "vue";
import axios from "axios";
import { urlApi } from "@/global";
export const catalogo = Vue.observable({ itens: [], carregando: false, carregado: false, erro: "", envioHabilitado: false });
let consulta;
export function mensagemErro(e) { return (e && e.response && e.response.data && e.response.data.error) || (e && e.message) || "Não foi possível concluir a operação."; }
export async function carregarDistribuidoras(atualizar = false) {
  if (consulta) return consulta;
  if (catalogo.carregado && !atualizar) return catalogo.itens;
  catalogo.carregando = true;
  catalogo.erro = "";
  consulta = Promise.all([
    axios.post(urlApi + "/listar-distribuidoras", {}),
    axios.post(urlApi + "/get-dados-sistema", {})
  ]).then(([lista, config]) => {
    catalogo.itens = lista.data.result;
    catalogo.envioHabilitado = !!config.data.result[0] && config.data.result[0].envioExternoHabilitado === true;
    catalogo.carregado = true;
    return catalogo.itens;
  }).catch(e => {
    catalogo.itens = [];
    catalogo.carregado = false;
    catalogo.envioHabilitado = false;
    catalogo.erro = mensagemErro(e);
    throw e;
  }).finally(() => { catalogo.carregando = false; consulta = null; });
  return consulta;
}
export function distribuidoraDoCliente(cliente) { return catalogo.itens.find(d => d.sold === cliente.sold); }
export function descricaoDistribuidora(cliente) {
  if (cliente.sold == null) return "Distribuidora pendente";
  if (catalogo.erro) return "Consulta de distribuidoras indisponível";
  if (!catalogo.carregado) return "Carregando distribuidora…";
  const d = distribuidoraDoCliente(cliente);
  return d ? d.nomeExibicao + (d.ativa ? "" : " (inativa)") : "SOLD não cadastrado: " + cliente.sold;
}

